import React from 'react'
import PropTypes from 'prop-types'
import { Select, MenuItem, Box } from '@material-ui/core'
import Moment from 'react-moment'

import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import { NONE } from '../../constants/commons'
import DateHelpers from '../../classes/DateHelpers'

export class CompetitiveShows extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    screenWidth: PropTypes.number,
    trackerPlan: PropTypes.object,
    trackerData: PropTypes.array,
    primarySelect: PropTypes.object,
    benchmarkSelect1: PropTypes.object,
    benchmarkSelect2: PropTypes.object,
    benchmarkSelect3: PropTypes.object,
    benchmarkSelect4: PropTypes.object,
    averageBenchmarkData: PropTypes.array,
    averageBenchmarkSelect: PropTypes.object,
    handleEntitySelectChange: PropTypes.func,
    handleAverageBenchmarkSelect: PropTypes.func,
    trackerAverageBenchMarkPlan: PropTypes.object,
    trackerAverageBenchMarkTimelineMetrics: PropTypes.object
  }

  render () {
    const { classes, trackerData, primarySelect, benchmarkSelect1, benchmarkSelect2, benchmarkSelect3, benchmarkSelect4, averageBenchmarkData, averageBenchmarkSelect, trackerAverageBenchMarkPlan } = this.props
    let averageBenchMark = (trackerAverageBenchMarkPlan.details) ? trackerAverageBenchMarkPlan.details.average_bench_mark : {}
    let averageBenchMarkName = (trackerAverageBenchMarkPlan.details) ? averageBenchMark.average_benchmark_display_name : ''
    const displayAverageBenchmark = averageBenchMark && averageBenchMark.display_average_benchmark
    return (
      <div className='dailyEngagementRowLegend'>
        { primarySelect &&
        <Select
          labelId="select-filled-label"
          id="select-filled"
          className='dailyEngagementSelect selectLegend1'
          value={primarySelect.name}
          onChange={(e) => this.props.handleEntitySelectChange(e, 1)}
        >
          { trackerData.map(t => {
            if (t.name !== NONE) {
              return (
                <MenuItem value={t.name} key={t.name} className='trackerSelect'>
                  <span className='dailyEngagementLegend dailyEngagementLegend1'></span>
                  <Box className="d-flex flex-column p-1">
                    <span className={classes.trackerSelectedGenreText}>{t.name}</span>
                    <span className={classes.selectedInfoText}>Premiere: <Moment format="MMM DD,YYYY">{DateHelpers.getDateWithoutTime(t.lookbackDate)}</Moment></span>
                  </Box>
                </MenuItem>
              )
            }
          })}
        </Select>
        }
        { benchmarkSelect1 &&
        <Select
          labelId="select-filled-label"
          id="select-filled"
          className='dailyEngagementSelect selectLegend2'
          value={benchmarkSelect1.name}
          onChange={(e) => this.props.handleEntitySelectChange(e, 2)}
        >
          { trackerData.map(t => {
            return (
              <MenuItem value={t.name} key={t.name} className='trackerSelect'>
                <span className='dailyEngagementLegend dailyEngagementLegend2'></span>
                <Box className="d-flex flex-column p-1">
                  <span className={classes.trackerSelectedGenreText}>{t.name}</span>
                  { t.name !== NONE &&
                    <span className={classes.selectedInfoText}>Premiere: <Moment format="MMM DD,YYYY">{DateHelpers.getDateWithoutTime(t.lookbackDate)}</Moment></span>
                  }
                </Box>
              </MenuItem>
            )
          })}
        </Select>
        }
        { benchmarkSelect2 &&
        <Select
          labelId="select-filled-label"
          id="select-filled"
          className='dailyEngagementSelect selectLegend3'
          value={benchmarkSelect2.name}
          onChange={(e) => this.props.handleEntitySelectChange(e, 3)}
        >
          { trackerData.map(t => {
            return (
              <MenuItem value={t.name} key={t.name}>
                <span className='dailyEngagementLegend dailyEngagementLegend3'></span>
                <Box className="d-flex flex-column p-1">
                  <span className={classes.trackerSelectedGenreText}>{t.name}</span>
                  { t.name !== NONE &&
                    <span className={classes.selectedInfoText}>Premiere: <Moment format="MMM DD,YYYY">{DateHelpers.getDateWithoutTime(t.lookbackDate)}</Moment></span>
                  }
                </Box>
              </MenuItem>
            )
          })}
        </Select>
        }
        { benchmarkSelect3 &&
        <Select
          labelId="select-filled-label"
          id="select-filled"
          className='dailyEngagementSelect selectLegend4'
          value={benchmarkSelect3.name}
          onChange={(e) => this.props.handleEntitySelectChange(e, 4)}
        >
          { trackerData.map(t => {
            return (
              <MenuItem value={t.name} key={t.name} className='trackerSelect'>
                <span className='dailyEngagementLegend  dailyEngagementLegend4'></span>
                <Box className="d-flex flex-column p-1">
                  <span className={classes.trackerSelectedGenreText}>{t.name}</span>
                  { t.name !== NONE &&
                    <span className={classes.selectedInfoText}>Premiere: <Moment format="MMM DD,YYYY">{DateHelpers.getDateWithoutTime(t.lookbackDate)}</Moment></span>
                  }
                </Box>
              </MenuItem>
            )
          })}
        </Select>
        }
        { benchmarkSelect4 &&
        <Select
          labelId="select-filled-label"
          id="select-filled"
          className='dailyEngagementSelect selectLegend5'
          value={benchmarkSelect4.name}
          onChange={(e) => this.props.handleEntitySelectChange(e, 5)}
        >
          { trackerData.map(t => {
            return (
              <MenuItem value={t.name} key={t.name}>
                <span className='dailyEngagementLegend dailyEngagementLegend5'></span>
                <Box className="d-flex flex-column p-1">
                  <span className={classes.trackerSelectedGenreText}>{t.name}</span>
                  { t.name !== NONE &&
                    <span className={classes.selectedInfoText}>Premiere: <Moment format="MMM DD,YYYY">{DateHelpers.getDateWithoutTime(t.lookbackDate)}</Moment></span>
                  }
                </Box>
              </MenuItem>
            )
          })}
        </Select>
        }
        { (averageBenchMarkName && displayAverageBenchmark && averageBenchmarkSelect) &&
          <Select
            labelId="select-filled-label"
            id="select-filled"
            className='dailyEngagementSelect selectLegendAvg'
            value={averageBenchmarkSelect.name}
            onChange={(e) => this.props.handleAverageBenchmarkSelect(e)}
          >
            { averageBenchmarkData.map(t => {
              return (
                <MenuItem value={t.name} key={t.name}>
                  <span className='dailyEngagementLegend dailyEngagementLegendAvg'></span>
                  <Box className="d-flex flex-column p-1">
                    <span className={classes.trackerSelectedGenreText}>{t.name}</span>
                  </Box>
                </MenuItem>
              )
            })}
          </Select>
        }
      </div>
    )
  }
}

export default withStyles(styles)(CompetitiveShows)